// Packages
import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"

// import getValue from 'object-getvalue';

// Components

// Actions

function PageInfo(props) {
  const {
    title,
    description,
    canonicalUrl = "http://www.davidyurman.com/",
  } = props //TODO: should get the canonical URL from somewhere else, ask Mike
  return (
    <div className="PageInfo">
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
    </div>
  )
}

PageInfo.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  canonicalUrl: PropTypes.string,
}

export default PageInfo
